import styled from "styled-components";

export const PackSlipHeaderContainer = styled.div`
  border-radius: 0.5rem;
  .rowItem {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 0.5em;
    margin-bottom: 0.5em;
    .label {
      font-weight: 500;
      color: #777;
    }
    .value {
      font-weight: 600;
      color: var(--accent);
    }
  }
`;
